/* unplugin-vue-components disabled */import { render } from "./SpeachTranslationSettings.vue?vue&type=template&id=2c8db25a&scoped=true&ts=true"
import script from "./SpeachTranslationSettings.vue?vue&type=script&lang=ts"
export * from "./SpeachTranslationSettings.vue?vue&type=script&lang=ts"

import "./SpeachTranslationSettings.vue?vue&type=style&index=0&id=2c8db25a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8db25a"]])

export default __exports__